export const empwiseattApi = {
    heading:[
        {
            head:"Punch Date"
        },
        {
            head:"Shift Time"
        },
        {
            head:"In Time"
        },
        {
            head:"Out Time"
        },
        {
            head:"Time Late"
        },
        {
            head:"Type"
        }
    ],
    data:[
       {
        userid:1138,
        id:2211261138,
        name:"Safayet",
        punchdate:"15-02-2023",
        shifttime:"08:00-17:00",
        intime:"45pm", 
        outtime:"15:00",
        timelate:"0",
        type:"",
        totalworkday:22,
        totalpresentday:20,
        totalabsent:2,
        totallate:5,
        totalearlyleave:6


       },
       {
        userid:1138,
        id:2211261138,
        punchdate:"16-02-2023",
        name:"Safayet",
        shifttime:"08:00-17:00",
        intime:"7:45am", 
        outtime:"15:00",
        timelate:"0",
        type:"",
        totalworkday:22,
        totalpresentday:20,
        totalabsent:2,
        totallate:5,
        totalearlyleave:6

       },
       {
        userid:1139,
        id:2211261139,
        punchdate:"16-02-2023",
        name:"Anik",
        shifttime:"08:00-17:00",
        intime:"7:45am", 
        outtime:"15:00",
        timelate:"0",
        type:"",
        totalworkday:22,
        totalpresentday:18,
        totalabsent:4,
        totallate:3,
        totalearlyleave:2

       },
     
       
    ]
}